import * as tslib_1 from "tslib";
import { Injector, OnChanges, SimpleChanges, } from '@angular/core';
import { BaseChart } from '@components/ui-chart/base-chart';
import { ChartLineStyle } from '@components/ui-chart/base-chart.types';
import { takeUntil } from 'rxjs/operators';
import { AXES_CHART_OPTIONS_MAPPER, COMMON_AXES_OPTIONS, mapBaseAxesColorOptions, } from './base-axes-chart.constants';
var BaseAxesChart = /** @class */ (function (_super) {
    tslib_1.__extends(BaseAxesChart, _super);
    function BaseAxesChart(_injector) {
        var _this = _super.call(this, _injector) || this;
        _this._injector = _injector;
        _this.xAxisLabelsRotation = 0;
        _this.showXAxisTickLines = true;
        _this.yAxisTickLineStyle = ChartLineStyle.Solid;
        _this.showGridBorder = true;
        _this.showAxes = true;
        _this.showLegend = true;
        _this._extendOptions(COMMON_AXES_OPTIONS);
        _this._colorProvider.changes$
            .pipe(takeUntil(_this._destroyed$))
            .subscribe(function () {
            _this._extendOptions(mapBaseAxesColorOptions(_this._colorProvider));
        });
        return _this;
    }
    BaseAxesChart.prototype.ngOnChanges = function (changes) {
        _super.prototype.ngOnChanges.call(this, changes);
        this._mapOptions(AXES_CHART_OPTIONS_MAPPER, changes);
    };
    return BaseAxesChart;
}(BaseChart));
export { BaseAxesChart };
